import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import useAuth from "../hooks/useAuth";

import Header, { NoHeaderScroll } from "../components/navigation/header";
import HomeCard from "../components/homeCard";

export default function Home() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, getUser } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/home") {
      if (user) {
        getUser({ id: user.id_usuario });
      }
    }
  }, [location]);

  const handleNavigation = (path) => {
    let code = path.toUpperCase().replace("/", "");
    const howTo = localStorage.getItem(`SPICY_HOWTO_${code}`);

    if (!howTo) {
      // How to play
      navigate(`${path}/how-to-play`);
      localStorage.setItem(`SPICY_HOWTO_${code}`, "true");
    } else {
      // Jogo
      let finalPath = path;

      // if (path === "/truth-or-dare") {
      //   finalPath = `${path}/game`;
      // }

      navigate(finalPath);
    }
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header />
      <NoHeaderScroll className="p-5 grid grid-cols-2 grid-flow-row gap-6 pt-10 pb-10">
        <HomeCard
          className="col-span-2"
          cardType="big"
          cardClass={"card-desafios"}
          image={require("../assets/images/layout/home/desafios.png")}
          text={t("nomeJogo1")}
          onClick={() => handleNavigation("/hot-challenges")}
        />
        <HomeCard
          cardClass={"card-toys"}
          image={require("../assets/images/layout/home/cenas.png")}
          text={t("nomeJogo4")}
          onClick={() => handleNavigation("/sex-roulette")}
          animationDelay="0.2s"
        />
        <HomeCard
          cardClass={"card-vod"}
          image={require("../assets/images/layout/home/vod.png")}
          text={t("nomeJogo2")}
          onClick={() => handleNavigation("/truth-or-dare")}
          animationDelay="0.4s"
        />
        <HomeCard
          cardClass={"card-roleplay"}
          cardType="roleplay"
          image={require("../assets/images/layout/home/roleplay.png")}
          text={`
            <span class="text-lg leading-[1.125rem]">Roleplay</span>
            <br>
            ${t("soon")}`}
          animationDelay="0.6s"
        />
        <HomeCard
          cardClass={"card-kama"}
          image={require("../assets/images/layout/home/kama.png")}
          text={"Kama365"}
          animationDelay="0.8s"
          onClick={() => handleNavigation("/kamasutra")}
        />
        <HomeCard
          cardClass={"card-solo"}
          cardType="solo"
          image={require("../assets/images/layout/home/solo.png")}
          text={t("playAlone")}
          onClick={() => navigate("/solo")}
          animationDelay="1s"
        />
        <HomeCard
          cardClass={"card-nivel"}
          cardType="nivel"
          image={require("../assets/images/layout/home/quiz.png")}
          text={t("nomeJogo3")}
          onClick={() => navigate("/quiz")}
          animationDelay="1.2s"
        />
      </NoHeaderScroll>
    </div>
  );
}
